import { createRouter, createWebHistory } from 'vue-router';

import Home from '../views/index.vue';
import store from '../store';

// Vue.use(VueRouter);
// import { createApp } from 'vue';
// const app = createApp();
// app.use(createRouter);

const routes = [
    //dashboard
    {   path: '/', 
        name: 'Home', 
        component: Home,
        meta: { layout: 'app', requiresAuth: true }
    },

    {
        path: '/dashboard-educador-digital',
        name: 'dashboard-educador-digital',
        component: () => import(/* webpackChunkName: "dashboard-educador-digital" */ '../views/DashboardEducadorDigital.vue'),
        meta: { layout: 'app', requiresAuth: true }
    },

    {
        path: '/financeiro',
        name: 'financeiro',
        component: () => import(/* webpackChunkName: "financeiro" */ '../views/financeiro.vue'),
        meta: { layout: 'app', requiresAuth: true }
    },

    {
        path: '/documentos',
        name: 'documentos',
        component: () => import(/* webpackChunkName: "anamneses" */ '../views/documentos/lista.vue'),
        meta: { layout: 'app', requiresAuth: true }
    },

    {
        path: '/revisoes-texto',
        name: 'revisoes-texto',
        component: () => import(/* webpackChunkName: "revisoes-texto" */ '../views/revisoes-texto/lista.vue'),
        meta: { layout: 'app', requiresAuth: true },
        async beforeEnter(to, from, next) {
            const { useUserStore } = await import('@/stores/user');
            const userStore = useUserStore();
            try {
                await userStore.getUser();
            } catch {
                /* ignorar */
            }
            const authUser = store.state.auth?.user;
            const v =
                userStore.user?.aceita_revisoes_texto_terceiros ??
                authUser?.aceita_revisoes_texto_terceiros;
            const ok = v === true || v === 1 || v === '1';
            if (!ok) {
                next({ name: 'Home' });
                return;
            }
            next();
        },
    },

    {
        path: '/documento/preview/:id',
        name: 'documento-preview',
        component: () => import(/* webpackChunkName: "documento-preview" */ '../views/documentos/PreviewRoute.vue'),
    },

    {
        path: '/documento/:id?',
        name: 'documento',
        component: () => import(/* webpackChunkName: "anamnese-adicionar" */ '../views/documentos/cadastrar.vue'),
        meta: { layout: 'app', requiresAuth: true }
    },

    {
        path: '/aluno/:id?',
        name: 'cadastro-paciente',
        component: () => import(/* webpackChunkName: "pacientes-cadastro" */ '../views/pacientes/cadastrar.vue'),
        meta: { layout: 'app', requiresAuth: true }
    },
    {
        path: '/aluno/detalhes/:id?',
        name: 'detalhes-paciente',
        component: () => import(/* webpackChunkName: "pacientes-detalhes" */ '../views/pacientes/detalhes.vue'),
        meta: { layout: 'app', requiresAuth: true }
    },
    {
        path: '/alunos',
        name: 'lista',
        component: () => import(/* webpackChunkName: "pacientes-lista" */ '../views/pacientes/lista.vue'),
        meta: { layout: 'app', requiresAuth: true }
    },

    {
        path: '/turmas',
        name: 'turmas',
        component: () => import(/* webpackChunkName: "turmas" */ '../views/turmas/lista.vue'),
        meta: { layout: 'app', requiresAuth: true }
    },
    
    {
        path: '/turma/:id?',
        name: 'turma',
        component: () => import(/* webpackChunkName: "turma-adicionar" */ '../views/turmas/cadastrar.vue'),
        meta: { layout: 'app', requiresAuth: true },
    },

    {
        path: '/turma/visualizar/:id',
        name: 'turma-visualizar',
        component: () => import(/* webpackChunkName: "turma-visualizar" */ '../views/turmas/show.vue'),
        meta: { layout: 'app', requiresAuth: true },
    },

    {
        path: '/temas',
        name: 'temas',
        component: () => import(/* webpackChunkName: "temas" */ '../views/temas/lista.vue'),
        meta: { layout: 'app', requiresAuth: true }
    },
    
    {
        path: '/tema/:id?',
        name: 'tema',
        component: () => import(/* webpackChunkName: "tema-adicionar" */ '../views/temas/cadastrar.vue'),
        meta: { layout: 'app', requiresAuth: true },
    },


    //auth
    {
        path: '/auth/confirmar-email',
        name: 'confirm-email-boxed',
        component: () => import(/* webpackChunkName: "auth-pass-recovery-boxed" */ '../views/auth/confirm_email_boxed.vue'),
        meta: { layout: 'auth' },
    },
    {
        path: '/auth/completar-cadastro',
        name: 'complet-register',
        component: () => import(/* webpackChunkName: "auth-pass-recovery-boxed" */ '../views/auth/completar_cadastro.vue'),
        meta: { layout: 'auth', requiresAuth: true },
    },
    {
        path: '/bem-vindo',
        name: 'bem-vindo',
        component: () => import(/* webpackChunkName: "auth-pass-recovery-boxed" */ '../views/auth/bem_vindo_page.vue'),
        meta: { layout: 'auth', requiresAuth: true },
    },
    {
        path: '/auth/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "auth-login" */ '../views/auth/login.vue'),
        meta: { layout: 'auth' },
    },
    {
        path: '/auth/register',
        name: 'register',
        component: () => import(/* webpackChunkName: "auth-register" */ '../views/auth/register.vue'),
        meta: { layout: 'auth' },
    },
    {
        path: '/auth/google/callback',
        name: 'google-callback',
        component: () => import(/* webpackChunkName: "auth-google-callback" */ '../views/auth/google-callback.vue'),
        meta: { layout: 'auth' },
    },

    {
        path: '/auth/recuperar-senha',
        name: 'recuperar-senha',
        component: () => import(/* webpackChunkName: "auth-recuperar-senha" */ '../views/auth/recuperar_senha.vue'),
        meta: { layout: 'auth' },
    },

    {
        path: '/auth/redefinir-senha',
        name: 'redefinir-senha',
        component: () => import(/* webpackChunkName: "auth-pass-recovery-change" */ '../views/auth/recuperar_senha_alterar.vue'),
        meta: { layout: 'auth' },
    },

    {
        path: '/termos-de-servico',
        name: 'termos-de-servico',
        component: () => import(/* webpackChunkName: "termos-de-servico" */ '../views/termos_de_servico.vue'),
        meta: { layout: 'auth' }
    },

    {
        path: '/politica-de-privacidade',
        name: 'politica-de-privacidade',
        component: () => import(/* webpackChunkName: "politica-de-privacidade" */ '../views/politica_privacidade.vue'),
        meta: { layout: 'auth' }
    },

    {
        path: '/aceite-legal',
        name: 'aceite-legal',
        component: () => import(/* webpackChunkName: "aceite-legal" */ '../views/legal/aceite_legal.vue'),
        meta: { layout: 'auth', requiresAuth: true }
    },

    {
        path: '/contato',
        name: 'contato',
        component: () => import(/* webpackChunkName: "contato" */ '../views/contato.vue'),
        meta: { layout: 'auth' }
    },

    //users
    {
        path: '/meus-dados',
        name: 'profile',
        component: () => import(/* webpackChunkName: "users-profile" */ '../views/users/profile.vue'),
        meta: { layout: 'app', requiresAuth: true }
    },
    {
        path: '/landing-page',
        name: 'landing-page-gerenciar',
        component: () => import(/* webpackChunkName: "landing-page-gerenciar" */ '../views/landing-page/GerenciarLandingPage.vue'),
        meta: { layout: 'app', requiresAuth: true },
        async beforeEnter(to, from, next) {
            const { useUserStore } = await import('@/stores/user');
            const { resolveIsAluno } = await import('@/utils/professorRole');
            const userStore = useUserStore();
            try {
                await userStore.getUser();
            } catch {
                /* ignorar */
            }
            const user = userStore.user || store.state.auth?.user;
            if (resolveIsAluno(user)) {
                next({ name: 'Home' });
                return;
            }
            next();
        },
    },
    {
        path: '/user/cadastro',
        name: 'cadastro-user',
        component: () => import(/* webpackChunkName: "cadastro-user" */ '../views/users/cadastro.vue'),
        meta: { layout: 'app', requiresAuth: true }
    },
    {
        path: '/users/account-setting',
        name: 'account-setting',
        component: () => import(/* webpackChunkName: "users-account-setting" */ '../views/users/account_setting.vue'),
    },
    {
        path: '/configuracoes/notificacoes',
        name: 'configuracoes-notificacoes',
        component: () => import(/* webpackChunkName: "configuracoes-notificacoes" */ '../views/users/configuracoes-notificacoes.vue'),
        meta: { layout: 'app', requiresAuth: true },
    },
    {
        path: '/modelos-avaliacao',
        name: 'modelos-avaliacao',
        component: () => import(/* webpackChunkName: "modelos-avaliacao" */ '../views/modelos-avaliacao/lista.vue'),
        meta: { layout: 'app', requiresAuth: true },
    },
    {
        path: '/modelos-avaliacao/:id/cores',
        name: 'modelo-avaliacao-cores',
        component: () => import(/* webpackChunkName: "modelo-avaliacao-cores" */ '../views/modelos-avaliacao/cores.vue'),
        meta: { layout: 'app', requiresAuth: true },
    },

    //planos
    {
        path: '/plano',
        name: 'plano',
        component: () => import(/* webpackChunkName: "plano" */ '../views/planos/index.vue'),
    },

    //checkout
    {
        path: '/checkout/:id',
        name: 'checkout',
        component: () => import(/* webpackChunkName: "checkout" */ '../views/faturas/preview.vue'),
    },

     //checkout
     {
        path: '/faturas',
        name: 'faturas',
        component: () => import(/* webpackChunkName: "list" */ '../views/faturas/list.vue'),
    },

    //prompts
    {
        path: '/prompts',
        name: 'prompts',
        component: () => import(/* webpackChunkName: "prompts" */ '../views/prompts/lista.vue'),
        meta: { layout: 'app', requiresAuth: true }
    },

    {
        path: '/prompt/:id?',
        name: 'prompt',
        component: () => import(/* webpackChunkName: "prompt-adicionar" */ '../views/prompts/cadastrar.vue'),
        meta: { layout: 'app', requiresAuth: true },
    },

    //venda
    {
        path: '/inscricao/turma/:id?',
        name: 'inscricao-turma',
        component: () => import(/* webpackChunkName: "inscricao-turma" */ '../views/venda/turma.vue'),
        meta: { layout: 'auth' },
    },

    {
        path: '/inscricao/confirmar/:id?',
        name: 'inscricao-turma-confirmar',
        component: () => import(/* webpackChunkName: "inscricao-turma" */ '../views/venda/preview.vue'),
        meta: { layout: 'auth' },
    },

    {
        path: '/inscricao/sucesso/:id?',
        name: 'inscricao-turma-sucesso',
        component: () => import(/* webpackChunkName: "inscricao-turma" */ '../views/venda/sucesso.vue'),
        meta: { layout: 'auth' },
    },

    {
        path: '/relatorios',
        name: 'relatorios',
        component: () => import(/* webpackChunkName: "relatorios" */ '../views/relatorios/index.vue'),
        meta: { layout: 'app', requiresAuth: true }
    },

    //planos de estudos
    {
        path: '/planos-estudos',
        name: 'planos-estudos',
        component: () => import(/* webpackChunkName: "planos-estudos" */ '../views/study-plans/lista.vue'),
        meta: { layout: 'app', requiresAuth: true }
    },
    {
        path: '/plano-estudo/criar/:id?',
        name: 'plano-estudo-criar',
        component: () => import(/* webpackChunkName: "plano-estudo-criar" */ '../views/study-plans/criar.vue'),
        meta: { layout: 'app', requiresAuth: true }
    },
    {
        path: '/plano-estudo/:id',
        name: 'plano-estudo',
        component: () => import(/* webpackChunkName: "plano-estudo-cadastrar" */ '../views/study-plans/cadastrar.vue'),
        meta: { layout: 'app', requiresAuth: true }
    },
    {
        path: '/planos-estudo/entrar/:token',
        name: 'planos-estudo-entrar-link',
        component: () => import(/* webpackChunkName: "planos-estudo-entrar-link" */ '../views/study-plans/entrar-por-link.vue'),
        meta: { layout: 'auth', requiresAuth: false }
    },

    //cursos
    {
        path: '/cursos',
        name: 'cursos-lista',
        component: () => import(/* webpackChunkName: "cursos-lista" */ '../views/courses/lista.vue'),
        meta: { layout: 'app', requiresAuth: true }
    },
    {
        path: '/cursos/entrar/:token',
        name: 'cursos-entrar-link',
        component: () => import(/* webpackChunkName: "cursos-entrar-link" */ '../views/courses/entrar-por-link.vue'),
        meta: { layout: 'auth', requiresAuth: false }
    },
    {
        path: '/curso/:id?',
        name: 'curso',
        component: () => import(/* webpackChunkName: "curso-cadastrar" */ '../views/courses/cadastrar.vue'),
        meta: { layout: 'app', requiresAuth: true }
    },
    {
        path: '/curso/:id/gerenciar',
        name: 'curso-gerenciar',
        component: () => import(/* webpackChunkName: "curso-gerenciar" */ '../views/courses/gerenciar.vue'),
        meta: { layout: 'app', requiresAuth: true }
    },
    {
        path: '/curso/:id/analytics',
        name: 'curso-analytics',
        component: () => import(/* webpackChunkName: "curso-analytics" */ '../views/courses/analytics.vue'),
        meta: { layout: 'app', requiresAuth: true }
    },
    {
        path: '/aula/:lessonId/quiz',
        name: 'quiz-gerenciar',
        component: () => import(/* webpackChunkName: "quiz-gerenciar" */ '../views/courses/quiz.vue'),
        meta: { layout: 'app', requiresAuth: true }
    },
    {
        path: '/recurso/:resourceId/quiz',
        name: 'recurso-quiz-gerenciar',
        component: () => import(/* webpackChunkName: "quiz-gerenciar" */ '../views/courses/quiz.vue'),
        meta: { layout: 'app', requiresAuth: true }
    },
    {
        path: '/plano-estudo/tarefa/:taskId/recurso/:resourceId/quiz',
        name: 'quiz-aluno',
        component: () => import(/* webpackChunkName: "quiz-aluno" */ '../views/study-plans/QuizAluno.vue'),
        meta: { layout: 'app', requiresAuth: true }
    },

    //recursos
    {
        path: '/recursos',
        name: 'recursos-lista',
        component: () => import(/* webpackChunkName: "recursos-lista" */ '../views/recursos/lista.vue'),
        meta: { layout: 'app', requiresAuth: true }
    },
    {
        path: '/recursos/cadastrar',
        name: 'recursos-cadastrar',
        component: () => import(/* webpackChunkName: "recursos-cadastrar" */ '../views/recursos/cadastrar.vue'),
        meta: { layout: 'app', requiresAuth: true }
    },
    {
        path: '/recurso/:id?',
        name: 'recurso',
        component: () => import(/* webpackChunkName: "recurso" */ '../views/recursos/editar.vue'),
        meta: { layout: 'app', requiresAuth: true }
    },

    //checklists
    {
        path: '/checklists',
        name: 'checklists',
        component: () => import(/* webpackChunkName: "checklists" */ '../views/checklists/lista.vue'),
        meta: { layout: 'app', requiresAuth: true }
    },
    {
        path: '/checklist/:id?',
        name: 'checklist',
        component: () => import(/* webpackChunkName: "checklist-cadastrar" */ '../views/checklists/cadastrar.vue'),
        meta: { layout: 'app', requiresAuth: true }
    },

    {
        path: '/marcacoes-ia-presets',
        name: 'marcacoes-ia-presets',
        component: () => import(/* webpackChunkName: "marcacoes-ia-presets" */ '../views/marcacoes-ia-presets/lista.vue'),
        meta: { layout: 'app', requiresAuth: true },
    },
    {
        path: '/marcacoes-ia-preset/:id?',
        name: 'marcacoes-ia-preset',
        component: () => import(/* webpackChunkName: "marcacoes-ia-preset" */ '../views/marcacoes-ia-presets/cadastrar.vue'),
        meta: { layout: 'app', requiresAuth: true },
    },

    //helpdesk (acessível sem login; menu lateral fechado por padrão)
    {
        path: '/ajuda',
        name: 'ajuda',
        component: () => import(/* webpackChunkName: "ajuda" */ '../views/helpdesk/helpdesk.vue'),
        meta: { layout: 'auth', requiresAuth: false }
    },

    // 404 — deve permanecer por último (Vue Router 4); layout auth = sem header/sidebar
    {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        component: () => import(/* webpackChunkName: "not-found" */ '../views/NotFound.vue'),
        meta: { layout: 'auth', requiresAuth: false },
    },

];

const router = createRouter({
    history: createWebHistory(),
    linkExactActiveClass: 'active',
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (typeof window === "undefined") return false;

        // Se há uma posição salva (navegação com botão voltar/avançar), use ela
        if (savedPosition) {
            return savedPosition;
        }

        if (to.name === 'not-found') {
            return { top: 0, left: 0 };
        }

        // Para recarregamento de página ou navegação direta, não force scroll
        // Deixa o navegador manter a posição natural
        return false;
    },
});

const PUBLIC_LEGAL_DOCUMENT_ROUTES = new Set(['termos-de-servico', 'politica-de-privacidade']);

function isPublicLegalDocumentRoute(to) {
    const path = (to.path || '').replace(/\/$/, '') || '/';
    return (
        path === '/termos-de-servico' ||
        path === '/politica-de-privacidade' ||
        PUBLIC_LEGAL_DOCUMENT_ROUTES.has(to.name)
    );
}

router.beforeEach(async (to, from, next) => {
    if (isPublicLegalDocumentRoute(to)) {
        store.commit('setLoading', false);
    } else {
        store.commit('setLoading', true);
    }

    if (!requiresAuth(to)) {
        // Não chama checkAuth nas telas de autenticação: evita GET /user concorrente ao POST /login
        // (401 em paralelo limpava a sessão logo após login bem-sucedido).
        const isAuthScreen =
            to.name === 'login' ||
            to.name === 'register' ||
            to.name === 'recuperar-senha' ||
            to.name === 'redefinir-senha' ||
            to.name === 'google-callback' ||
            to.name === 'termos-de-servico' ||
            to.name === 'politica-de-privacidade';

        // Rotas públicas (ex.: /ajuda): ainda tenta carregar auth para menu quando já houver sessão/token.
        try {
            const alreadyAuthenticated = store.getters['auth/isAuthenticated'];
            if (!isAuthScreen && !alreadyAuthenticated) {
                await store.dispatch('auth/checkAuth');
            }
        } catch (e) {
            // Ignora erro (usuário não logado); a rota é acessível mesmo assim
        }
        // Na Central de Ajuda: sidebar já entra fechado e sem animação
        if (to.name === 'ajuda') {
            store.commit('setSidebarSkipTransition', true);
            store.commit('toggleSideBarAuto', false);
        }
        setLayout(to);
        return next();
    }

    try {
        const alreadyAuthenticated = store.getters['auth/isAuthenticated'];
        if (!alreadyAuthenticated) {
            await store.dispatch('auth/checkAuth');
        }
        const isAuthenticated = store.getters['auth/isAuthenticated'];

        if (!isAuthenticated) {
            console.log('Not authenticated, redirecting to login');
            return redirectToLogin(to, next);
        }

        if (needsConfirmeEmail(to)) {
            console.log('Needs email confirmation, redirecting');
            return redirectToConfirmeEmail(to, next);
        }

        const legalRedirect = mustRedirectLegalAccept(to, store.state.auth.user);
        if (legalRedirect) {
            return next(legalRedirect);
        }

        setAuthenticatedLayout(to);
        return next();
    } catch (error) {
        console.error('Authentication check failed', error);
        return handleAuthError(to, next);
    }
});

// Garante que a página já tenha carregado antes de remover a tela de loading
router.beforeResolve((to, from, next) => {
    store.commit('setLoading', false);
    next();
});

router.afterEach(() => {
    store.commit('setLoading', false);
});

// Tratamento global de erros
router.onError((error) => {
    console.error('Erro de navegação:', error);
    store.commit('setLoading', false);
});

function requiresAuth(to) {
    return to.matched.some(record => record.meta.requiresAuth);
}

function setLayout(to) {
    const layout = to.meta?.layout || 'app';
    store.commit('setLayout', layout === 'auth' ? 'auth' : 'app');
}

function redirectToLogin(to, next) {
    setLayout(to);
    next({ name: 'login', query: { redirect: to.fullPath } });
}

function needsConfirmeEmail(to) {
    return !store.getters['auth/isConfirmatedEmail'] && to.name !== 'confirm-email-boxed';
}

function redirectToConfirmeEmail(to, next) {
    next({ name: 'confirm-email-boxed', params: { redirect: to.fullPath } });
}

function needsRegistrationCompletion(to) {
    return !store.getters['auth/isCompleteRegistration'] && to.name !== 'complet-register';
}

function redirectToCompleteRegistration(to, next) {
    next({ name: 'complet-register', params: { redirect: to.fullPath } });
}

function setAuthenticatedLayout(to) {
    setLayout(to);
}

function handleAuthError(to, next) {
    setLayout(to);
    next({ name: 'login', query: { redirect: to.fullPath } });
}

/**
 * Bloqueia rotas autenticadas até aceitar Termos + Privacidade vigentes na API (LGPD / versionamento).
 */
function mustRedirectLegalAccept(to, user) {
    if (!user || typeof user !== 'object') {
        return null;
    }
    const legal = user.legal;
    if (!legal?.consents_active || !legal?.blocking_enforced) {
        return null;
    }
    const allowed = new Set([
        'aceite-legal',
        'termos-de-servico',
        'politica-de-privacidade',
    ]);
    if (allowed.has(to.name)) {
        return null;
    }
    return { name: 'aceite-legal', query: { redirect: to.fullPath } };
}

export default router;